import { render } from "./List.vue?vue&type=template&id=8f83323a&scoped=true"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"

import "./List.vue?vue&type=style&index=0&id=8f83323a&lang=scss&scoped=true"

import exportComponent from "/var/www/miniapp-property-b2b/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f83323a"],['__file',"src/assets/js/components/Form/List.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8f83323a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8f83323a', __exports__)) {
    api.reload('8f83323a', __exports__)
  }
  
  module.hot.accept("./List.vue?vue&type=template&id=8f83323a&scoped=true", () => {
    api.rerender('8f83323a', render)
  })

}


export default __exports__